import { Component, Input } from '@angular/core';

@Component({
  selector: 'ngx-progress',
  template: `
    <div
      class="progress pos-rel"
      [style.zIndex]="zIndex"
      [style.width.px]="size"
      [style.height.px]="size">
      <div
        class="spinner bg-white"
        [style.width.px]="size * 0.7"
        [style.height.px]="size * 0.7">
        <div
          class="spinner-icon"
          [style.border-color]="color">
        </div>
      </div>
      <div class="spinner-text body-4 text-grey-400 text-500">{{ percentage }}%</div>
    </div>
  `,
  styles: [
    `
      .progress {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .spinner {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10%;
        border-style: solid;
        border-width: 0.2em;
        animation: spinner-animation 2s cubic-bezier(.5, .05, .1, .3) infinite;
      }

      .spinner-icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 10%;
        border-style: solid;
        border-width: 0.2em;
        border-top-color: transparent;
        border-right-color: transparent;
      }

      .spinner-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding-bottom: 1px;
      }

      @keyframes spinner-animation {
        0% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(180deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class ProgressComponent {
  @Input() percentage: number | string = 100;
  @Input() size = 50;
  @Input() color = '#039FCE'; // accent-500
  @Input() zIndex = 100;
}
